import React from "react";
import { IssueLogPanel } from "../IssueLogPanel";
import { useCurrentRightPanel } from "../useCurrentRightPanel";

export const IssuesPanel = React.memo<{}>(() => {
  const { activeIssueId, activePanelType, closePanel } = useCurrentRightPanel();
  return (
    <div
      style={{ marginLeft: 1, marginBottom: 5 }}
      data-dd-action-name="<MASKED-DATA>"
    >
      <IssueLogPanel
        onClose={closePanel}
        onRestoreSuccess={() => {}}
        panelType={activePanelType}
        issueId={activeIssueId}
      />
    </div>
  );
});
